const perpageBanner = document.getElementById('perpagebanner');

if (perpageBanner) {

    var bannerId = perpageBanner.getAttribute('data-pageid'); 
    const localStorageVar = bannerId;
	const showAgainAfterMs = 24 * 60 * 60 * 1000;
    const dismissedUntilTime = localStorage.getItem(localStorageVar) || 0;

    //check if banner has already been shown
    if (!dismissedUntilTime && new Date().getTime() > dismissedUntilTime) {
        perpageBanner.classList.remove('hidden');
    }
    
	// set localStorage to remember not to show banner if its been dismissed recently
	const setLocalStorage = () => {
		const whenToShowAgain = new Date().getTime() + showAgainAfterMs;
		localStorage.setItem(localStorageVar, whenToShowAgain);
	};
	// click close button, dismiss
	document.addEventListener('click', (event) => {
		if (event.target.matches('.perpagebanner-closer')) {
			event.preventDefault();
			perpageBanner.classList.remove('enabled');
			setLocalStorage();
		}
	}, false);

}
